import React from 'react';
import { Box, Button, Container, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { MoonStarIcon, PhoneIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { brand, whatsappHref } from '../data/brand';
const navLinks = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: '¿Por qué consultarnos?',
  href: '#por-que'
}, {
  label: 'Nosotros',
  href: '#nosotros'
}, {
  label: 'Galería',
  href: '#galeria'
}, {
  label: 'Experiencias',
  href: '#experiencias'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  return <Box as="header" position="sticky" top={0} zIndex={20} bg="plum.950" borderBottom="1px solid" borderColor="whiteAlpha.200" data-id="element-125" data-mp="31c8lknbizwr2">
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} data-id="element-126" data-mp="36cwa92ca81i4">
        <Flex align="center" justify="space-between" py={{
        base: 3,
        md: 4
      }} gap={4} data-id="element-127" data-mp="3bb65te1x5449">
          <HStack as="a" href="#inicio" spacing={3} align="center" _hover={{
          opacity: 0.9
        }} data-id="element-128" data-mp="3fayk87dzu4hj">
            <Flex align="center" justify="center" w="2.5rem" h="2.5rem" borderRadius="full" border="1px solid" borderColor="gold.400" color="gold.300" flexShrink={0} data-id="element-129" data-mp="2wl4gasn3kah9">
              <MoonStarIcon size={20} aria-hidden="true" data-id="element-130" data-mp="2hodaa0ix40io" />
            </Flex>
            <Box lineHeight={1.15} data-id="element-131" data-mp="3fb2mf37c3ti9">
              <Text fontFamily="heading" fontSize={{
              base: 'md',
              md: 'lg'
            }} fontWeight={600} color="cream.50" data-id="element-132" data-mp="3fa10g3os5mlr">
                Templo de Ayuda Esotérica
              </Text>
              <Text display={{
              base: 'none',
              sm: 'block'
            }} fontSize="0.68rem" letterSpacing="0.18em" textTransform="uppercase" color="gold.300" data-id="element-133" data-mp="30mpo3zkrxykl">
                Orientación espiritual · Miami, FL
              </Text>
            </Box>
          </HStack>

          <HStack as="nav" aria-label="Navegación principal" spacing={7} display={{
          base: 'none',
          lg: 'flex'
        }} data-id="element-134" data-mp="1re37dys28yhg">
            {navLinks.map(link => <Link key={link.href} href={link.href} fontSize="sm" fontWeight={500} color="plum.100" _hover={{
            color: 'gold.200',
            textDecoration: 'none'
          }} data-id="element-135" data-mp="1ho1gkz8bp1yu">
                {link.label}
              </Link>)}
          </HStack>

          <HStack spacing={2} flexShrink={0} data-id="element-136" data-mp="1cq8cqcuhsk1q">
            <Button as="a" href={brand.phoneHref} variant="goldOutline" size="sm" leftIcon={<PhoneIcon size={15} aria-hidden="true" data-id="element-138" data-mp="13oilb70m1l3y" />} display={{
            base: 'none',
            sm: 'inline-flex'
          }} data-id="element-137" data-mp="yp5q9yzl57qa">
              {brand.phone}
            </Button>
            <Button as="a" href={brand.phoneHref} variant="goldOutline" size="sm" display={{
            base: 'inline-flex',
            sm: 'none'
          }} aria-label={`Llamar al ${brand.phone}`} px={3} data-id="element-139" data-mp="2y0yr66phux8a">
              <PhoneIcon size={16} aria-hidden="true" data-id="element-140" data-mp="w4psttqpwrza" />
            </Button>
            <Button as="a" href={whatsappHref()} target="_blank" rel="noopener noreferrer" variant="whatsapp" size="sm" leftIcon={<WhatsAppIcon size={16} data-id="element-142" data-mp="106kvb1kdxben" />} data-id="element-141" data-mp="re13ajylm52s">
              WhatsApp
            </Button>
          </HStack>
        </Flex>
      </Container>
    </Box>;
}